// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.alert {
  padding: 0.2rem;
  margin: 0.5rem 0;
  font-size: 0.9rem;
}

html {
  min-width: 375px;
  scroll-behavior: smooth;
}

.dark-mode-switcher {
  font-size: 1.4rem;
}

.menu-assets {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 1rem;
}

.menu-group-name, .menu-company-name {
  font-size: 0.7rem;
}

.cursor-pointer {
  -webkit-user-select: none;
          user-select: none;
  cursor: pointer;
}

.width-150 {
  width: 150px;
}

.width-200 {
  width: 200px;
}

.max-width-115 {
  max-width: 115px;
}

.max-width-65 {
  max-width: 65px;
}

.modal {
  --bs-modal-zindex: 1050 !important;
}

.modal-80w {
  min-width: 80%;
}

.modal-60w {
  min-width: 60%;
}

.modal-content {
  min-width: 360px;
}

@media (max-width: 575px) {
  .table {
    font-size: 0.95rem;
  }

}

@media (max-width: 767px) {
  .display-none {
      display: none;
  }

  .menu-assets {
    justify-content: flex-start;
    flex-direction: column;
    margin: 0;
    padding: 0;
    align-items: center;
    gap: 0.5rem;
  }

  .menu-assets.container {
    padding: 0 1.5rem 0 0;
  }

  .mobile-menu {
    max-width: 75% !important;
  }

  .mobile-menu-name-group-container {
    display: flex;
  }

  .mobile-menu-icons-container {
    display: flex;
    justify-content: flex-start;
    width: 100%;
    gap: 1rem;
  }

  .btn-close {
    position: absolute;
    align-self: center;
    right: 10px;
    top: 10px;
    font-size: 1rem;
  }
}

.PATCH_modal { 
    touch-action: none;
    overscroll-behavior: none;
    overflow: hidden;
    -webkit-overflow-scrolling: auto;
}

@media (max-width: 991px) {
  .nav-link {
    padding-left: 0.25rem !important;
    padding-right: 0.25rem !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAiB;UAAjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,kBAAkB;EACpB;;AAEF;;AAEA;EACE;MACI,aAAa;EACjB;;EAEA;IACE,2BAA2B;IAC3B,sBAAsB;IACtB,SAAS;IACT,UAAU;IACV,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,2BAA2B;IAC3B,WAAW;IACX,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,eAAe;EACjB;AACF;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;EACE;IACE,gCAAgC;IAChC,iCAAiC;EACnC;AACF","sourcesContent":["* {\r\n  margin: 0;\r\n  padding: 0;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.alert {\r\n  padding: 0.2rem;\r\n  margin: 0.5rem 0;\r\n  font-size: 0.9rem;\r\n}\r\n\r\nhtml {\r\n  min-width: 375px;\r\n  scroll-behavior: smooth;\r\n}\r\n\r\n.dark-mode-switcher {\r\n  font-size: 1.4rem;\r\n}\r\n\r\n.menu-assets {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  align-items: center;\r\n  flex-direction: row;\r\n  flex-wrap: wrap;\r\n  gap: 1rem;\r\n}\r\n\r\n.menu-group-name, .menu-company-name {\r\n  font-size: 0.7rem;\r\n}\r\n\r\n.cursor-pointer {\r\n  user-select: none;\r\n  cursor: pointer;\r\n}\r\n\r\n.width-150 {\r\n  width: 150px;\r\n}\r\n\r\n.width-200 {\r\n  width: 200px;\r\n}\r\n\r\n.max-width-115 {\r\n  max-width: 115px;\r\n}\r\n\r\n.max-width-65 {\r\n  max-width: 65px;\r\n}\r\n\r\n.modal {\r\n  --bs-modal-zindex: 1050 !important;\r\n}\r\n\r\n.modal-80w {\r\n  min-width: 80%;\r\n}\r\n\r\n.modal-60w {\r\n  min-width: 60%;\r\n}\r\n\r\n.modal-content {\r\n  min-width: 360px;\r\n}\r\n\r\n@media (max-width: 575px) {\r\n  .table {\r\n    font-size: 0.95rem;\r\n  }\r\n\r\n}\r\n\r\n@media (max-width: 767px) {\r\n  .display-none {\r\n      display: none;\r\n  }\r\n\r\n  .menu-assets {\r\n    justify-content: flex-start;\r\n    flex-direction: column;\r\n    margin: 0;\r\n    padding: 0;\r\n    align-items: center;\r\n    gap: 0.5rem;\r\n  }\r\n\r\n  .menu-assets.container {\r\n    padding: 0 1.5rem 0 0;\r\n  }\r\n\r\n  .mobile-menu {\r\n    max-width: 75% !important;\r\n  }\r\n\r\n  .mobile-menu-name-group-container {\r\n    display: flex;\r\n  }\r\n\r\n  .mobile-menu-icons-container {\r\n    display: flex;\r\n    justify-content: flex-start;\r\n    width: 100%;\r\n    gap: 1rem;\r\n  }\r\n\r\n  .btn-close {\r\n    position: absolute;\r\n    align-self: center;\r\n    right: 10px;\r\n    top: 10px;\r\n    font-size: 1rem;\r\n  }\r\n}\r\n\r\n.PATCH_modal { \r\n    touch-action: none;\r\n    overscroll-behavior: none;\r\n    overflow: hidden;\r\n    -webkit-overflow-scrolling: auto;\r\n}\r\n\r\n@media (max-width: 991px) {\r\n  .nav-link {\r\n    padding-left: 0.25rem !important;\r\n    padding-right: 0.25rem !important;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
